export enum SortByOption {
  'All',
  'Visited Person',
  'Type of Visit',
  'Date of Visit',
  'Visit Status',
  'Crisis Visits',
}

export enum TypeOfVisit {
  'Community Based',
  'In Office',
  'Voice Call',
  'Video Call',
  'Hospital',
}

export const visitTypes = {
  InPerson: 'Community Based',
  InPersonOnSite: 'In Office',
  VoiceCall: 'Voice Call',
  VideoCall: 'Video Call',
  Hospital: 'Hospital',
};

export enum VisitedPerson {
  'Client',
  'Collateral Contact',
  'No Show',
  'Hospital Staff',
  'AOT Contact',
}
